import A from '../actions/afspLoginActions';

const init = {
    home: null,
    view: 'login',
    showLoginModal: false,
    showLoginStatusModal: false,
    showPasswordResetModal: false,
    loginButtonDisabled: true,
    loginRequest: {
        status: null,
        error: null,
        code: null
    },
    passwordResetRequest: {
        status: null,
        error: null,
        code: null
    },
    generateReactivateEmail: {
        status: null,
        error: null,
        code: null
    }
}

export default (state=init, action) => { switch(action.type) {
    case A.TOGGLE_AFSP_LOGIN_MODAL: return {...state, showLoginModal: !state.showLoginModal };
    case A.TOGGLE_AFSP_LOGIN_STATUS_MODAL: return {...state, showLoginStatusModal: !state.showLoginStatusModal };
    case A.TOGGLE_AFSP_PASSWORD_RESET_MODAL: return {...state, showPasswordResetModal: !state.showPasswordResetModal };
    case A.TOGGLE_AFSP_LOGIN_BUTTON_DISABLE: return {...state, loginButtonDisabled: !state.loginButtonDisabled };
    case A.CHANGE_AFSP_LOGIN_MODAL_VIEW: return {...state, view: action.payload };

    case A.AFSP_LOGIN_REQUEST_PENDING: 
        return {...state, loginRequest: {...state.loginRequest, status: 'pending' }};
    
    case A.AFSP_LOGIN_REQUEST_SUCCESS: 
        return {...state, loginRequest: {...state.loginRequest, status: 'success' }};

    case A.AFSP_LOGIN_REQUEST_FAILURE: 
        return {...state, loginRequest: {...state.loginRequest, 
            status: 'failure',
            code: action.payload.status
        }};

    case A.AFSP_PASSWORD_RESET_REQUEST_PENDING: 
        return {...state, passwordResetRequest: {...state.passwordResetRequest, status: 'pending' }};

    case A.AFSP_PASSWORD_RESET_REQUEST_SUCCESS: 
        return {...state, passwordResetRequest: {...state.passwordResetRequest, status: 'success' }};

    case A.AFSP_PASSWORD_RESET_REQUEST_FAILURE: 
        return {...state, passwordResetRequest: {...state.passwordResetRequest, status: 'failure' }};

    case A.REACTIVATE_USER_PENDING: 
        return {...state, generateReactivateEmail: {...state.generateReactivateEmail, status: 'pending' }};


    case A.REACTIVATE_USER_SUCCESS: 
        return {...state, generateReactivateEmail: {...state.generateReactivateEmail, status: 'success' },
        loginRequest: {...state.loginRequest, 
            status: 'failure',
            code: 459
        }};

    case A.REACTIVATE_USER_FAILURE: 
        return {...state, generateReactivateEmail: {...state.generateReactivateEmail, status: 'failure' },
        loginRequest: {...state.loginRequest, 
            status: 'failure',
            code: 459
        }};

    case A.RESET_AFSP_LOGIN_REQUEST: return {...state, loginRequest: {
        status: null,
        error: null,
        code: null
    }};

    case A.RESET_AFSP_PASSWORD_RESET_REQUEST: return {...state, passwordResetRequest: {
        status: null,
        error: null,
        code: null
    }};

    default: return {...state};
}}